<script setup lang="ts">
import { ref } from 'vue';

import { useIsFetching, useIsMutating } from '@tanstack/vue-query';
import { watchImmediate } from '@vueuse/core';

const isFetching = useIsFetching();
const isMutating = useIsMutating();
const showGlobalLoader = ref(false);
let globalLoaderTimeout: ReturnType<typeof setTimeout>;

watchImmediate([isFetching, isMutating], (newValue) => {
  if (newValue.some((a) => a > 0)) {
    showGlobalLoader.value = true;
    clearTimeout(globalLoaderTimeout);
  } else {
    globalLoaderTimeout = setTimeout(() => {
      showGlobalLoader.value = false;
    }, 1000);
  }
});
</script>

<template>
  <PProgressBar v-data-qa-auto-id="'TheGlobalLoader'"
    mode="indeterminate"
    :class="{ hidden: !showGlobalLoader }"
    class="absolute inset-x-0 top-0 h-[2px] transition-opacity duration-500"
    :pt="{ value: 'bg-content-color/50' }"
  />
</template>
